import { Box, Link, Typography } from '@mui/material';
import { isPossiblePhoneNumber } from 'libphonenumber-js';
import { memo } from 'react';

import { formatPhoneNumber } from 'shared/lib/formatPhoneNumber/formatPhoneNumber';
import { isEmail } from 'shared/lib/lodash/lodash';

type PropertyCardRowProps = {
    name: string;
    value: string | number;
    minimized?: boolean;
    bordered?: boolean;
};

export const PropertyCardRow = memo(
    ({ name, value = '', minimized, bordered }: PropertyCardRowProps) => {
        const output = isPossiblePhoneNumber(value.toString() as string, 'US')
            ? formatPhoneNumber(value.toString() as string)
            : value;

        const isEmailValue = isEmail(output as string);

        return (
            <Box
                p={!minimized ? '15px 0 17px' : '6px 0 7px'}
                display="flex"
                flexDirection={isEmailValue ? 'column' : 'row'}
                borderBottom={bordered ? '1px solid' : undefined}
                borderColor="divider"
                justifyContent={isEmailValue ? undefined : 'space-between'}
                alignItems={isEmailValue ? 'flex-start' : undefined}
                data-testclass={`attribute`}
            >
                <Typography
                    variant={minimized ? 'body2' : 'body1'}
                    color="text.primary"
                    data-testclass="label"
                    pr="16px"
                >
                    {name}
                </Typography>
                <Typography
                    component={isEmailValue ? Link : undefined}
                    maxWidth={isEmailValue ? undefined : '340px'}
                    color={isEmailValue ? 'blue.500' : 'text.secondary'}
                    href={isEmailValue ? `mailto:${output}` : undefined}
                    rel={isEmailValue ? 'noopener noreferrer' : undefined}
                    variant={minimized ? 'body2' : 'body1'}
                    borderColor="blue.500"
                    textAlign={isEmailValue ? undefined : 'right'}
                    sx={isEmailValue ? { wordBreak: 'break-all' } : undefined}
                    data-testclass="value"
                >
                    {output}
                </Typography>
            </Box>
        );
    },
);
